module.exports = __webpack_public_path__ + "static/media/app-image-with-text.96b15df7.png";